import {
  ERROR,
  WARNING,
  SUCCESS,
  CLOSE_NOTIFICATION,
  SUCCESS_LOGIN,
  INFO
} from '#action/types';

const defaultState = {
  open: false,
  variant: 'success'
};

export default function reducerNotification(state = defaultState, action) {
  switch (action.type) {
    case ERROR:
      const { errorMessage, message } = action.payload;

      if (
        errorMessage === 'Unauthorized' &&
        (window.location.pathname === '/' ||
          window.location.pathname === '/login')
      ) {
        return defaultState;
      }

      return {
        open: true,
        variant: 'error',
        ...action.payload,
        message: errorMessage || message
      };
    case WARNING:
      return {
        open: true,
        variant: 'warning',
        ...action.payload
      };
    case SUCCESS:
      return {
        open: true,
        variant: 'success',
        ...action.payload
      };
    case SUCCESS_LOGIN:
      return {
        open: true,
        variant: 'success',
        ...action.payload,
        signedIn: true
      };
    case INFO:
      return {
        open: true,
        variant: 'info',
        ...action.payload
      };
    case CLOSE_NOTIFICATION:
      return { open: false, variant: state.variant };
    default:
      return state;
  }
}
